import type { YachtTime } from '@constants/types'

import type { UpdateTimeConfig } from '../actions'
import { UPDATE_TIME } from '../actions'

const initialState: YachtTime = { value: '', model: '' }

const timeReducer = (state = initialState, action: UpdateTimeConfig) => {
  if (action.type === UPDATE_TIME) {
    return {
      value: action.payload.value,
      model: action.payload.model
    }
  } else {
    return state
  }
}

export default timeReducer
